export default __webpack_public_path__ + "static/callout-bg-145dabbd339790f3bad242793f5b6f27.jpg";